import { ReactElement } from 'react'

import CreatePasswordImpl from 'modules/user/domain/usecases/CreatePasswordImpl'
import SignInImpl from 'modules/auth/domain/usecases/SignInImpl'
import { useAuth } from 'modules/auth/hooks/auth'
import AuthRepository from 'modules/auth/infra/repositories/AuthRepository'

import UserRepository from '../../infra/repositories/UserRepository'
import NewPassword from '../../pages/NewPassword'

export const NewPasswordFactory = (): ReactElement => {
  const userRepository = new UserRepository()
  const createPasswordImpl = new CreatePasswordImpl(userRepository)
  const authRepository = new AuthRepository()
  const signInImpl = new SignInImpl(authRepository)

  const { signIn } = useAuth()

  return (
    <NewPassword
      createPassword={createPasswordImpl}
      signIn={signInImpl}
      signInStore={signIn}
    />
  )
}
